import React from 'react';
import ReactDOM from 'react-dom/client';
import 'mapbox-gl/dist/mapbox-gl.css';
/* eslint-disable import/no-webpack-loader-syntax */
import mapboxgl from 'mapbox-gl';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./index.scss";
// @ts-ignore
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
